import { createAction, props } from '@ngrx/store';

export const setPlayAudioState = createAction(
  '[PlayAudio] Set play audio state',
  props<{ state: boolean }>(),
);
